import {Component, OnInit} from '@angular/core';
import {NgbDateStruct, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.component';
import {OfficeCoupon} from 'src/app/classes/OfficeCoupon';
import {OfficeCouponsService} from 'src/app/services/office-coupons.service';
import {CouponEditComponent} from '../coupon-edit/coupon-edit.component';
import {CouponStatus} from 'src/app/enums/CouponStatus';

@Component({
  selector: 'app-coupon-list',
  styleUrls: ['./coupon-list.component.scss'],
  templateUrl: './coupon-list.component.html',
})
export class CouponListComponent implements OnInit {

  public coupons: OfficeCoupon[];
  public errorMessage: string;
  public CouponStatus = CouponStatus;
  private currentDialog = null;
  public couponStatuses = CouponStatus;
  public couponStatusKeys: string[];
  public filterForm: FormGroup;

  constructor(private couponService: OfficeCouponsService,
              private modalService: NgbModal,
              private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.couponStatusKeys = Object.keys(CouponStatus);

    this.filterForm = this.formBuilder.group({
      couponStatus: [CouponStatus.READY]
    });

    this.filterForm.controls.couponStatus.valueChanges.subscribe(() => this.refreshList());

    this.refreshList();
  }

  refreshList(): void {

    let status = this.filterForm.controls.couponStatus.value;
    if (status === 'ALL') {
      status = null;
    }

    this.couponService.getAll(status).subscribe({
      next: (coupons) => {
        this.coupons = coupons;
      },
      error: (error) => this.errorMessage = error.error.error
    });
  }

  openEditModal(coupon: OfficeCoupon): void {
    this.currentDialog = this.modalService.open(CouponEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-coupon-edit',
        size: 'lg',
        centered: true,
      });

    this.currentDialog.componentInstance.coupon = coupon;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {

          const expirationDate =
            this.convertNgbDate(result.controls.expirationDate.value, 0, 0, 0, false);
          result.controls.expirationDate.setValue(expirationDate);

          const editedCoupon = new OfficeCoupon(result.value);

          this.couponService.addOrEdit(editedCoupon).subscribe({
            next: () => this.refreshList(),
            error: (error) => this.errorMessage = error.error.error
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(coupon: OfficeCoupon): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-coupon-delete-confirm',
        size: 'md',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want delete coupon with id ' + coupon.id + '?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.couponService.delete(coupon.id).subscribe({
          next: () => this.refreshList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }

  convertNgbDate(ngbDate: NgbDateStruct, hours: number, minutes: number, seconds: number, nextDayTransfer: boolean): Date {

    if (!ngbDate) {
      return null;
    }

    // if hours is 00:00, then set next day
    if (hours === 0 && minutes === 0 && nextDayTransfer) {
      ngbDate.day = ngbDate.day + 1;
    }

    const date = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day, hours, minutes, seconds);

    return ngbDate ? date : null;
  }

}
